import { render, staticRenderFns } from "./PassWithOpinion.vue?vue&type=template&id=477777e8&scoped=true&"
import script from "./PassWithOpinion.vue?vue&type=script&lang=js&"
export * from "./PassWithOpinion.vue?vue&type=script&lang=js&"
import style0 from "./PassWithOpinion.vue?vue&type=style&index=0&id=477777e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477777e8",
  null
  
)

export default component.exports